"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
// import useMinifiedActions from '../../../CreateUrlModal/helpers/minifiedActions'
var download_1 = require("../../../../../app/util/download");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        downloadButtonContainer: (_a = {
                marginLeft: 20,
                width: '150px',
                flexShrink: 0
            },
            _a[theme.breakpoints.down('sm')] = {
                marginLeft: 0,
            },
            _a),
        downloadButton: {
            height: '100%',
            width: '150px',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            border: "1px solid " + theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
        },
    });
});
var DownloadButton = function () {
    var _a = __read(react_i18next_1.useTranslation(), 1), t = _a[0];
    var classes = useStyles();
    var tableConfig = react_redux_1.useSelector(function (state) { return state.user.tableConfig; });
    return (
    // Only shown when actions are not minified.
    react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: classes.downloadButtonContainer },
            react_1.default.createElement(core_1.Button, { variant: "outlined", onClick: function () { return download_1.downloadUrls(tableConfig); }, className: classes.downloadButton },
                react_1.default.createElement(core_1.Typography, { variant: "body2" }, t('button.downloadLink'))))));
};
exports.default = DownloadButton;
